import { Box, Stack, TextField, Typography } from "@mui/material";
import classNames from "classnames/bind";
import React, { useEffect, useState } from "react";
import styles from "./index.module.css";

const PopUp = ({ img, title, update, value, toggle }) => {
  const cx = classNames.bind(styles);
  const [ogValue, setOgValue] = useState(value);
  const [input, setInput] = useState(value);
  const handleCancel = () => {
    update(ogValue);
    toggle();
  }
  const handleTextChange = () => {
    update(input);
  }
  useEffect(() => {
    handleTextChange();
  }, [input]);

  return (
    <Box className={cx("modal")}>
      <Box className={cx("pop-up-box")}>
        <Stack direction="row" spacing={2} alignItems="flex-end">
          <img src={img} alt="logo" style={{ width: "22%" }} />
          <Box component="form" noValidate>
            <Typography fontSize="0.5em" color="#868181" paddingBottom="1.5%">
              貼上您的{title}連結：
            </Typography>
            <TextField
              required
              id="outlined-required"
              className={cx("text-field")}
              onChange={(e) => {
                setInput(e.target.value);
              }}
              defaultValue={input}
              size="small"
            />
          </Box>
        </Stack>
        <Stack
          direction="row"
          justifyContent="flex-end"
          width="100%"
          paddingRight="0.9em"
          spacing={2}
        >
          <button className={cx("cancel-btn")} onClick={handleCancel}>
            <Typography fontSize="0.5em" color="#575757">
              取消
            </Typography>
          </button>
          <button className={cx("confirm-btn")} onClick={toggle}>
            <Typography fontSize="0.5em" color="#575757">
              確定
            </Typography>
          </button>
        </Stack>
      </Box>
    </Box>
  );
};

export default PopUp;
